// PremiumLogin.js
import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
  Paper,
  InputAdornment,
  IconButton,
  CircularProgress,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import authService from '../Auth/AuthService';
import { useNavigate } from 'react-router-dom';
import { color } from 'framer-motion';

const Login = () => {
  const [formData, setFormData] = useState({ username: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const navigate = useNavigate();
  const name = localStorage.getItem("name");
  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Login:', formData);
    try {

      const rest = authService.pathUrl("POST", "/auth/login");
      const tokendata = await authService.registerLogin(rest, formData);

      if (tokendata?.is_verfied === true || tokendata?.roles === "SUPPERADMIN") {
        navigate("/");
      } else if (tokendata?.is_verfied === false)
        navigate("/verify");
      else
        navigate("/loginview");
      window.location.reload();
    } catch (e) {
      const msg = {
        icon: 'error',
        title: 'Account Inactive',
        text: e.message + ' Or Your account has now been deactivated'
      }
      setTimeout(() => setIsDisabled(false), 7000);
      // authService.showSwal(msg)
    }
  };

  const register = () => { navigate("/register") }

  return (
    <Box
      sx={{
        height: '100vh',
        // background: 'linear-gradient(to right, #6a11cb, #2575fc)',
        // background: '#040000',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Paper
        elevation={10}
        sx={{
          p: 5,
          width: 400,
          color: '#fff',
          borderRadius: 5,
          textAlign: 'center',
          backgroundColor: '#022c47',
          border: '1px solid #575858',
          backdropFilter: 'blur(10px)', '&:hover': {
            backgroundColor: '#0b2b40',
            // border: '2px solid #795200',
            border: '3px solid #0b2b40',
            // color: '#fff',
            boxShadow: '0px 0px 20px 0px #0b2b40'
          },
        }}
      >
        <Typography variant="h5" fontWeight={600} gutterBottom sx={{ fontFamily: 'monospace' }}>
          {name !== 'undefined' ? name : "JMK"}
        </Typography>
        <Typography variant="subtitle1" mb={3}>
          Welcome Back | Sign in to continue
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            label="User Name"
            name="username"
            fullWidth
            variant="outlined"
            value={formData.username}
            onChange={handleChange}
            margin="normal"
            slotProps={{
              inputLabel: {
                sx: {
                  color: "white",
                  "&.Mui-focused": {
                    color: "white",
                  },
                },
              },
              notchedOutline: {
                sx: {
                  borderColor: "white !important",
                },
              },
            }}
            sx={{
              borderRadius: 2,
              "& .MuiInputBase-input": {
                backgroundColor: "#0b2b40",
                color: "white",
              },
              "& .MuiInputBase-input:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 1000px #0b2b40 inset !important",
                WebkitTextFillColor: "white !important",
                caretColor: "white",
              },
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#485057 !important",
                },
                "&:hover fieldset": {
                  borderColor: "#485057 !important",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#485057 !important",
                  borderWidth: "1px",
                },
              },
            }}
          />

          <TextField
            label="Password"
            name="password"
            fullWidth
            variant="outlined"
            type={showPassword ? "text" : "password"}
            value={formData.password}
            onChange={handleChange}
            margin="normal"
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword(!showPassword)} sx={{ color: 'white' }}>
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              },
              inputLabel: {
                sx: { color: "white", "&.Mui-focused": { color: "white" } }
              },
              notchedOutline: {
                sx: { borderColor: "#485057" }
              }
            }}
            sx={{
              borderRadius: 2,
              "& .MuiInputBase-input": {
                backgroundColor: "#0b2b40",
                color: "white",
              },
              "& .MuiInputBase-input:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 1000px #0b2b40 inset !important",
                WebkitTextFillColor: "white !important",
                caretColor: "white",
              },
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#485057 !important",
                },
                "&:hover fieldset": {
                  borderColor: "#485057 !important",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#485057 !important",
                  borderWidth: "1px",
                },
              },
            }}
          // sx={{
          //   "& .MuiInputBase-input": {
          //     backgroundColor: "black",
          //     color: "white",
          //   },
          //   "& .MuiInputBase-input:-webkit-autofill": {
          //     WebkitBoxShadow: "0 0 0 1000px black inset !important",
          //     WebkitTextFillColor: "white !important",
          //     caretColor: "white",
          //   },
          //   "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
          //     borderColor: "white",
          //   },
          //   "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
          //     borderColor: "white",
          //   },
          // }}
          />


          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{
              mt: 3,
              border: '1px solid #505050',
              bgcolor: '#0b2b40',
              fontWeight: 'bold',
              fontSize: '16px',
              paddingY: 1,
              borderRadius: 6,
              '&:hover': {
                backgroundColor: '#0f3752',
                border: '1px solid #686969',
              },
            }}
          >
            {isDisabled ? <CircularProgress size={20} sx={{ color: '#fff' }} /> : "Login"}
          </Button>
        </form>
        <Typography variant="body2" mt={3} onClick={() => register()}>
          Don't have an account? Register Now
        </Typography>
      </Paper>
    </Box>
  );
};

export default Login;
